export default __webpack_public_path__ + "static/media/Max125_Frente.13771ace.webp";